module.exports = __webpack_public_path__ + "img/blank.970366b9.png";